import { Injectable, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { SelectedItemOutput } from '@wilson/shift-timeline/assignments-gantt-chart';
import {
  AddActivityToUnassignedRegion,
  RemoveShiftWithoutActivitiesFromUnassignedRegion,
  TimelineRemoveActivityFromUnassignedRegion,
  TimelineUpsertActivityToUnassignedRegion,
} from '@wilson/shift-timeline/state';
import { Subscription } from 'rxjs';
import { ActivityDrawerCloseActionType } from '../components/drawers/TimelineActivityDrawer/timeline-activity-drawer.service';
import { TimelineCommonOperationsService } from './timeline-common-operations.service';
import { UpdateShiftOnActivityDragService } from './update-shift-on-activity-drag.service';

@Injectable({
  providedIn: 'root',
})
export class UnassignedActivityDrawerService {
  private readonly store = inject(Store);
  private readonly timelineCommonOperationsService = inject(
    TimelineCommonOperationsService,
  );
  private readonly updateShiftOnActivityDragService = inject(
    UpdateShiftOnActivityDragService,
  );

  private subscriptions = new Subscription();

  async openActivityDrawer(event: SelectedItemOutput): Promise<void> {
    this.subscriptions.unsubscribe(); // unsubscribe from previous subscriptions
    this.subscriptions.add(
      this.timelineCommonOperationsService
        .openActivityDrawer(event)
        .subscribe(async (action) => {
          if (
            action?.type === ActivityDrawerCloseActionType.UPDATE &&
            action.activity.shiftId
          ) {
            await this.updateShiftOnActivityDragService.updateShiftOnUnassignedRegion(
              action.activity.shiftId,
            );
            this.store.dispatch(
              new TimelineUpsertActivityToUnassignedRegion(
                action.activity,
                action.activity.shiftId,
              ),
            );
          } else {
            if (action?.type === ActivityDrawerCloseActionType.DELETE_SHIFT) {
              this.store.dispatch(
                new RemoveShiftWithoutActivitiesFromUnassignedRegion({
                  shiftId: action.shiftId,
                }),
              );
            } else if (
              action?.type ===
              ActivityDrawerCloseActionType.DISSOCIATE_FROM_SHIFT
            ) {
              this.store.dispatch(
                new TimelineRemoveActivityFromUnassignedRegion(
                  action.activity.id as string,
                  action.activity.shiftId as string,
                ),
              );
              this.store.dispatch(
                new AddActivityToUnassignedRegion(action.activity),
              );
              await this.updateShiftOnActivityDragService.updateOrDeleteShiftOnUnassignedRegion(
                action.activity.id as string,
                action.activity.shiftId as string,
              );
            } else if (
              action?.type === ActivityDrawerCloseActionType.DELETE &&
              action.activity.shiftId //This check is important because we will implement drawer for unassigned activity as well
            ) {
              await this.updateShiftOnActivityDragService.updateOrDeleteShiftOnUnassignedRegion(
                action.activity.id as string,
                action.activity.shiftId,
              );
              this.store.dispatch(
                new TimelineRemoveActivityFromUnassignedRegion(
                  action.activity.id as string,
                  action.activity.shiftId,
                ),
              );
            }
            this.subscriptions.unsubscribe();
          }
        }),
    );
  }
}
